import type { BarDescriptor } from "../state/composition.js";
import { formatPct } from "../state/format.js";

interface Props {
  bar: BarDescriptor;
}

/**
 * One right-pane bar. Height encodes the current % (0–100 of the track); colour
 * encodes instrument (call blue / put gold); fill encodes aggressor (solid=ask,
 * hollow=bid). A dashed line marks the intraday high-water %, with a "hi NN"
 * label when the current value has fallen below it.
 */
export function CompositionBar({ bar }: Props): JSX.Element {
  const fillClass = [
    "comp-bar__fill",
    `comp-bar__fill--${bar.group}`,
    bar.fill === "hollow" ? "comp-bar__fill--hollow" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="comp-bar">
      <div className="comp-bar__track">
        <div className={fillClass} style={{ height: `${clampPct(bar.pct)}%` }} />
        <div className="comp-bar__hi" style={{ bottom: `${clampPct(bar.highWaterPct)}%` }}>
          {bar.belowHigh ? <span className="comp-bar__hi-label">{bar.hiLabel}</span> : null}
        </div>
      </div>
      <span className="comp-bar__pct">{formatPct(bar.pct)}</span>
      <span className="comp-bar__cap">{bar.label}</span>
    </div>
  );
}

function clampPct(n: number): number {
  return Math.max(0, Math.min(100, n));
}
